import { Typography, MenuItem, Select } from '@material-ui/core'
import Grid from '@material-ui/core/Grid'
import Paper from '@material-ui/core/Paper'
import { makeStyles } from '@material-ui/core/styles'
import React, { useEffect, useState } from 'react'
import lodashGet from 'lodash.get'

const useStyles = makeStyles((theme) => ({
    cell: {
        alignItems: 'center',
        justifyContent: 'center',
        display: 'flex',
    },
    container: {
        marginTop: theme.spacing(2),
        padding: theme.spacing(0.5),
    },
    errorBorder: {
        borderColor: theme.palette.error.main,
    },
    errorText: {
        color: theme.palette.error.dark,
    },
    inputsWrapper: {
        display: "flex",
        flexDirection: "column",
        alignItems: 'center'
    },
    droupdownWidth: {
        minWidth: "120px"
    }
}))

const HelloStackFeatureToggle = ({ name, description, feat, errorMsg, updateHelloStack}) => {
    const classes = useStyles()
    const [stackName, setStackName] = useState('');

    const helloStacks = ["Core", "Coles"]

    useEffect(() => {
        setStackName(lodashGet(feat, 'name', ''))
    }, [feat, errorMsg])

    const onChangeStackName = async (event) => {
        const newValue = event.target.value;

        setStackName(newValue)
        updateHelloStack({name: newValue})
    }

    return (
        <Paper {...getContainerProps(errorMsg)}>
            <Grid container>
                <Grid className={classes.cell} item xs={3}>
                    <Typography variant="body1">{name}</Typography>
                </Grid>
                <Grid className={classes.cell} item xs={6}>
                    <Typography variant="body1" align="center">
                        {description}
                    </Typography>


                </Grid>
                <Grid className={classes.inputsWrapper} item xs={3}>
                    <Select
                        value={stackName}
                        onChange={onChangeStackName}
                        className={classes.droupdownWidth}
                    >
                        {helloStacks.map((stack) => (
                            <MenuItem key={stack} value={stack} selected={stackName === stack ? true : false}>
                                {stack}
                            </MenuItem>
                        ))}
                    </Select>
                </Grid>
            </Grid>
            {errorMsg ? (
                <Grid item xs={12}>
                    <Typography variant="body1" align="center" className={classes.errorText}>
                        {errorMsg}
                    </Typography>
                </Grid>
            ) : (
                <></>
            )}
        </Paper>
    )
}

const getContainerProps = (errorMsg) => {
    const classes = useStyles()

    return {
        className: classes.container + (errorMsg ? ' ' + classes.errorBorder : ''),
        variant: errorMsg ? 'outlined' : undefined,
        elevation: 0,
    }
}

export default HelloStackFeatureToggle
